// extracted by mini-css-extract-plugin
module.exports = {"text":"StatementTab_text__3qgfR","text_end":"StatementTab_text_end__pDCan","text_address":"StatementTab_text_address__1ZjRY","textArea":"StatementTab_textArea__3sdaG"};